import { render, staticRenderFns } from "./MetricasReport.vue?vue&type=template&id=04b95fde&scoped=true"
import script from "./MetricasReport.vue?vue&type=script&lang=js"
export * from "./MetricasReport.vue?vue&type=script&lang=js"
import style0 from "./MetricasReport.vue?vue&type=style&index=0&id=04b95fde&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b95fde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b95fde')) {
      api.createRecord('04b95fde', component.options)
    } else {
      api.reload('04b95fde', component.options)
    }
    module.hot.accept("./MetricasReport.vue?vue&type=template&id=04b95fde&scoped=true", function () {
      api.rerender('04b95fde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/MetricasReport.vue"
export default component.exports